import type {LocaleV3} from '@smart/locale-service';
import {safeJsonParse} from '@smart/utils';
import {INTERRUPTION_START_PATHS} from '../constants';
import type {HistoryPath} from '../hooks';
import {getLanguageMappedPaths} from './get-language-mapped-paths';

interface GetInterruptionPage {
  interruptionType: 'interruption' | 'inactivity';
  locale: LocaleV3;
  path: HistoryPath;
}

export function getInterruptionPage({
  interruptionType,
  locale,
  path,
}: GetInterruptionPage) {
  const isInactivity = interruptionType === `inactivity`;

  const previousFullPathDecoded = decodeURIComponent(
    `${path[isInactivity ? `currentPath` : `previousPath`]}${
      path[isInactivity ? `currentLocationSearch` : `previousLocationSearch`]
    }`,
  );
  const paths = getLanguageMappedPaths(INTERRUPTION_START_PATHS, locale);
  const interruptedPath = paths.find(
    (_path) => decodeURIComponent(_path) === previousFullPathDecoded,
  );

  if (!interruptedPath) {
    return `unknown`;
  }

  const withQueryString = interruptedPath.split(`?`)[1];

  if (!withQueryString) {
    const page = interruptedPath.split(`/${locale.language}`)[1];

    if (!page) {
      return `unknown`;
    }
    return page;
  }

  const params = new URLSearchParams(withQueryString);
  const paramsObj = params.get(`---`);

  if (!paramsObj) {
    return `unknown`;
  }
  const parsedParams = safeJsonParse<{'shopping-cart': string}>(paramsObj);

  if (!parsedParams) {
    return `unknown`;
  }

  return parsedParams[`shopping-cart`];
}
